import Vue from "vue";
import Router from "vue-router";
import UserManage from "./modules/user-manage";
import AuthorityManage from "./modules/authority-manage";
import LiveManage from "./modules/live-manage.js";
import operation from "./modules/operation-manage.js";

import teacher from "./modules/teacher-manage.js";
import student from "./modules/student-manage.js";
import school from "./modules/school-manage.js";
import edu from "./modules/edu-manage.js";
import order from "./modules/order-manage.js";
import data from "./modules/data-analysis.js";
import product from "./modules/product-manage.js";

import Store from "../store/index";

const Login = () => import("@/vuepage/Login");
const Index = () => import("@/vuepage/Index");
Vue.use(Router);

const children = [
  ...AuthorityManage,
  ...UserManage,
  ...LiveManage,
  ...operation,
  ...data,
  ...order,
  ...edu,
  ...school,
  ...student,
  ...teacher,
  ...product,
];

const router = new Router({
  routes: [
    {
      path: "",
      redirect: "/admin-list",
    },
    {
      path: "/login",
      component: Login,
    },
    {
      path: "/index",
      component: Index,
      children: [
        {
          path: "/Home",
          component: (resolve) => require(["@/vuepage/home/index.vue"], resolve),
          meta: [
            {
              name: "概况",
              activeRoute: "/",
            },
          ],
        },
        ...children,
      ],
    },
  ],
  // mode: 'history',
});

const keepAliveRouter = ["PurchaseRecord", "UserDetail", "UserList"]; // 请先配置好组件的name属性和路由的name保持一致
Store.dispatch("addKeepAlive", keepAliveRouter);
router.beforeEach((to, from, next) => {
  const pageContainer = document.getElementById("page-container");
  setTimeout(() => {
    if (pageContainer && pageContainer.scrollTop) {
      pageContainer.scrollTop = 0;
    }
  }, 500);
  if (keepAliveRouter.includes(to.name)) {
    Store.dispatch("addKeepAlive", to.name);
  }
  next();
});

export default router;
